import { AddBahasaPayload } from "../../../../models/Bahasa";
import { AddDivisiPayload, EditDivisiPayload } from "../../../../models/Divisi";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { fetchAllDivisiKey } from "../../queries/Divisi/useFetchAllDivisi";
import getQueryClient from "../../queryClient";

export async function editDivisi(data: EditDivisiPayload) {
  const res = await ApiClient.put(`/EditDivisi`, data);
  return res.data;
}

export const useEditDivisi = mutationWrapper(editDivisi, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(fetchAllDivisiKey);
  },
});
